import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import cx from "classnames";

class TextFieldCmp extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    autoComplete: PropTypes.string,
    label: PropTypes.string,
    translatedLabel: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string
    }),
    intl: intlShape.isRequired,
    type: PropTypes.string,
    hidden: PropTypes.bool
  };

  render() {
    const {
      textarea = false,
      input,
      label,
      autoComplete,
      placeholder,
      disabled,
      meta: { touched, error, warning },
      translatedLabel,
      intl,
      type = "text",
      hidden,
      className
    } = this.props;

    const labelToUse =
      translatedLabel || label
        ? translatedLabel || intl.formatMessage({ id: label })
        : "";
    const placeholderToUse = placeholder
      ? intl.formatMessage({ id: placeholder })
      : "";

    const inputElement = textarea ? "textarea" : "input";
    return (
      <div
        className={cx("TextField", className)}
        style={{ display: hidden ? "none" : "" }}
      >
        {labelToUse && <label>{labelToUse}</label>}
        <div className="field-wrapper">
          {React.createElement(inputElement, {
            ...input,
            autoComplete: autoComplete,
            placeholder: placeholderToUse,
            type: type,
            disabled: disabled || false
          })}
          {touched &&
            ((error && (
              <span className="TextField__Error">
                <FormattedMessage id={error} />
              </span>
            )) ||
              (warning && (
                <span className="TextField__Warning">
                  <FormattedMessage id={warning} />
                </span>
              )))}
        </div>
      </div>
    );
  }
}

const TextField = props => <Field component={TextFieldCmp} {...props} />;

export default injectIntl(TextField);



// WEBPACK FOOTER //
// ./src/modules/forms/fields/text-field.js